import React from "react";
import { Button, Icon } from "@mui/material";
import { Editor } from "slate";
import { useSlate } from "slate-react";

import { classes } from "../../styles";
import { CustomEditor } from "../../custom-types";

interface IProps {
  format: string;
  icon: string;
  disabled?: boolean;
}

export const MarkButton: React.FC<IProps> = ({
  format,
  icon,
  disabled = false,
}) => {
  const editor = useSlate();

  const isMarkActive = (editor: CustomEditor, format: string) => {
    const marks = Editor.marks(editor);
    return marks ? marks[format] === true : false;
  };

  const handleMarkButton = (editor: CustomEditor, format: string) => {
    const isActive = isMarkActive(editor, format);

    if (isActive) {
      Editor.removeMark(editor, format);
    } else {
      Editor.addMark(editor, format, true);
    }
  };

  return (
    <Button
      size="small"
      variant="contained"
      disabled={disabled}
      disableElevation={!isMarkActive(editor, format)}
      color={isMarkActive(editor, format) ? "secondary" : "primary"}
      sx={classes.button}
      onClick={(event) => {
        event.preventDefault();
        handleMarkButton(editor, format);
      }}
    >
      <Icon fontSize="small" sx={classes.icon}>
        {icon}
      </Icon>
    </Button>
  );
};
